import { Component, Input, EventEmitter,Output, ViewChild, SimpleChanges } from '@angular/core';
// import 'chart.piecelabel.js'; // Comentado - puede no ser compatible con Chart.js v4
import { BaseChartDirective } from 'ng2-charts'
import { ChartDataset, ChartOptions } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

@Component({
    selector: 'mh-chart-pie',
    templateUrl: './pie-chart.component.html',
    styleUrls: ['../../../../assets/scss/shared/charts/pie-chart.scss'],
    standalone: false
})
export class PieChartComponent{

  @Input()
  waiting: boolean = false;

  @Input()
  pieLabels;

  @Input()
  datasets: ChartDataset[];

  @Input()
  colors: Array<any> = [{}];

  @Input()
  positionLegend:string='top';

  @Input()
  pointer:boolean = true;

  @Input()
  size: number = 400;

  @Output()
  pieChartClick = new EventEmitter<any>();

  @ViewChild(BaseChartDirective) chartComponent: BaseChartDirective | undefined;

  public pieChartType: 'pie' = 'pie';
  public pieChartData: any = { labels: [], datasets: [] };
  public pieChartPlugins: any[] = [ChartDataLabels];

  public pieOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    layout: {
      padding: {
        top: 15,
        bottom: 15,
        left: 15,
        right: 15
      }
    },
    elements: {
      arc: {
        borderWidth: 0.5,
        borderColor: '#ffffff'
      }
    },
    plugins: {
      legend: {
        position: this.positionLegend as any,
        fullSize: false,
        maxWidth: 200,
        labels: {
          boxWidth: 10,
          font: {
            weight: 'bold',
            size: 11
          },
          padding: 8,
          usePointStyle: true
        },
        onHover: (event: any) => {
          if (event?.native?.target?.style) {
            event.native.target.style.cursor = 'pointer';
          }
        }
      },
      tooltip: {
        enabled: true,
        displayColors: false,
        callbacks: {
          label: (context) => {
            const dataset = context.dataset;
            const total = (dataset.data as number[]).reduce((a, b) => a + b, 0);
            const value = context.parsed as number;
            const percent = (context.chart.data as any).inPercent ? value : Math.round(value/total*1000)/10;
            return percent+'%';
          },
          title: (tooltipItems) => {
            const context = tooltipItems[0];
            const label = context.label;
            const dataset = context.dataset;
            const numbers = (dataset as any).numbers || dataset.data || [];
            const count = !(context.chart.data as any).inPercent ? numbers[context.dataIndex] : undefined;
            return count ? (label+': '+count) : label;
          }
        }
      },
      datalabels: {
        display: true,
        color: '#ffffff',
        anchor: 'center' as any,
        align: 'center' as any,
        font: {
          weight: 'bold' as any,
          size: 14
        },
        formatter: (value: any, context: any) => {
          const dataset = context.dataset;
          const dataArray = dataset.data as number[];
          const total = dataArray.reduce((a: number, b: number) => a + b, 0);
          
          // No mostrar si el valor es 0
          if (value === 0 || total === 0) return null;
          
          // Calcular porcentaje
          let percent: number;
          if ((context.chart.data as any).inPercent) {
            percent = value;
          } else {
            percent = (value / total) * 100;
          }
          
          // No mostrar si la pieza es muy pequeña (menos de 5%)
          if (percent < 5) return null;
          
          // Redondear: si el decimal es >= 0.5 redondear arriba, sino abajo
          const roundedPercent = (percent % 1) >= 0.5 ? Math.ceil(percent) : Math.floor(percent);
          
          return roundedPercent + '%';
        }
      }
    },
    onHover: (event: any, activeElements: any[], chart: any) => {
      if (event?.native?.target?.style) {
        if (activeElements.length && this.pointer) {
          event.native.target.style.cursor = 'pointer';
        } else {
          event.native.target.style.cursor = 'default';
        }
      }
    }
  };

  constructor() {
    // pieceLabel plugin configurado en las opciones
    // Comentado temporalmente - puede no ser compatible con Chart.js v4
    // (this.pieOptions as any)['pieceLabel'] = {
    //   render: function (args) {
    //     let key        = Object.keys(args["dataset"]._meta)[0]
    //     let controller = args["dataset"]._meta[key]
    //     let showing    = controller ? controller.data.filter(x=>!x.hidden) : [];
    //     let data       = controller ? showing.map(x=>args["dataset"].data[x._index]) : args["dataset"].data;
    //     let total      = data.reduce((a, b) => a + b, 0);
    //     let percent    = args.percentage ? args.percentage : args.value*100/total;
    //     
    //     // Redondear según si el decimal es mayor o igual a 0.5 o menor
    //     let roundedPercent = (Math.round(percent * 10) / 10) % 1 >= 0.5 ? Math.ceil(percent) : Math.floor(percent);

    //     return roundedPercent+'%';
    //   },
    //   fontColor: 'white'
    // };
  }

  ngOnInit(){
    this.updateChartData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['positionLegend']) {
      this.pieOptions = {
        ...this.pieOptions,
        plugins: {
          ...this.pieOptions.plugins,
          legend: {
            ...this.pieOptions.plugins.legend,
            position: this.positionLegend as any,
            fullSize: false,
            maxWidth: 200
          }
        }
      };
    }

    if (changes['datasets'] || changes['pieLabels'] || changes['colors']) {
      this.updateChartData();
    }
  }

  updateChartData() {
    if (!this.datasets || !this.pieLabels) {
      this.pieChartData = { labels: [], datasets: [] };
      return;
    }

    // Combinar datasets con colors
    const datasets = this.datasets.map((dataset: any, index: number) => {
      const colorConfig = this.colors?.[index] || {};
      return {
        ...dataset,
        backgroundColor: colorConfig.backgroundColor || dataset.backgroundColor,
        borderColor: '#ffffff', // Líneas divisorias blancas
        borderWidth: 1, // Grosor de las líneas divisorias
        hoverBackgroundColor: colorConfig.hoverBackgroundColor || dataset.hoverBackgroundColor,
        hoverBorderColor: '#ffffff', // Mantener líneas blancas en hover
        hoverBorderWidth: 1, // Mantener grosor en hover
      };
    });

    this.pieChartData = {
      labels: this.pieLabels,
      datasets: datasets
    };
  }

  public chartClicked(e:any):void {
    this.pieChartClick.emit(e);
  }

  public chartHovered(e:any):void {
  }

}
